/* eslint new-cap:0 */
import _ from 'underscore';
import ko from 'knockout';
import { KoSchema } from '@bingads-webui/ko-schema';

export default class ViewModel {
  constructor({
    deps,
    editSchema,
    model,
    bidProperty,
    validators,
  } = {}) {
    KoSchema(this, editSchema, _.keys(model), model, {}, deps.i18n);

    _.each(validators, (validatorsOfKey, key) => {
      _.each(validatorsOfKey, (validator) => {
        _.each(_.omit(validator, 'type'), (value, rule) => {
          this[key].validators[validator.type][rule] = value;
        });
      });
    });

    this.bidOptions = [{
      text: deps.i18n.getString('ProductGroupsGrid_Bid_Included'),
      value: false,
    }, {
      text: deps.i18n.getString('ProductGroupsGrid_Bid_Excluded'),
      value: true,
    }];

    this.requiredMessage = ko.computed(() => {
      const isValid = this.IsExcluded() ||
        !(_.isNull(this[bidProperty]()) || _.isUndefined(this[bidProperty]()));

      return isValid ? '' : deps.i18n.getString('ProductGroupsGrid_BidFormat_Validation');
    });

    this.isBidValid = ko.computed(() =>
      this[bidProperty].isValid() && _.isEmpty(this.requiredMessage()));

    this.IsExcluded.string = ko.computed({
      read() {
        return this.IsExcluded() ? 'true' : 'false';
      },
      write(newValue) {
        this.IsExcluded(newValue === 'true');
      },
    }, this);
  }
}
